// extracted by mini-css-extract-plugin
export default {"TabsBlock":"TabsBlock_TabsBlock__w3zjk","Title":"TabsBlock_Title__2NLUv"};